import { combineReducers } from "redux";
import user from "./user.reducer"
import {toastsReducer as toasts} from 'react-toastify-redux';
import mapData from './map-data.reducer'
import filter from './filter.reducer'
import ui from './ui.reducer'
import fleet from './fleet.reducer'
import alert from './alert.reducer'
import suggestions from './suggestions.reducer'
import services from './services.reducer'
import companyVesselChartData from './company-vessel-chart.reducer'
import vessel from './vessel.reducer'

export default combineReducers({
  user,
  toasts,
  mapData,
  filter,
  ui,
  fleet,
  alert,
  suggestions,
  services,
  companyVesselChartData,
  vessel
});